import { atom } from "recoil";

export const onboardingFormDataAtom = atom({
  key: "onboardingFormDataState",
  default: {},
});
